import $ from 'jquery';

const logoShapeBg = () => {
  const logoShapeElem = $('.has-logo-shape-bg');

  if (logoShapeElem.length) {
    $.each(logoShapeElem, (i, el) => {
      $(el).wrapInner('<span class="has-logo-shape-inner"></span>');
    });
  }
};

export default logoShapeBg();



// WEBPACK FOOTER //
// ./src/scripts/modules/logo-shape-bg.js